import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/take';
import { UsuariosPersonalService } from './services/usuarios-personal.service';

@Injectable()
export class AppGuard implements CanActivate {
  constructor(
    private usuariosPerosonalService: UsuariosPersonalService,
    private afAuth: AngularFireAuth) { }

  canActivate(route, state): Observable<boolean> | Promise<boolean> | boolean {
    return this.afAuth.authState
      .take(1)
      .map(auth => {
        this.usuariosPerosonalService.auth = auth;
        let rutaActual = route.routeConfig.path;
        if (auth) {
          //valida que el cliente este loguueado
          if(rutaActual === "clientes"){
            return true;
          }

          //cometar esta linea para que el redireccionamiento por rol y autenticacion se deshabilite
          /*
          if(rutaActual === "planeacion" && auth.displayName === "monitoreo"){
            return true;
          }
          if(rutaActual === "mantenimiento" && auth.displayName === "finanzas"){
            return true;
          }
          
          return rutaActual === auth.displayName;
          */
        return true; // esta linea solo valida que el usuario este loggeado
        } else {
          return false;
        }
      });
  }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/app.guard.ts